export const NAV_ITEMS = [
  { type: 'link', path: '/', labelKey: 'Home' },
  {
    type: 'dropdown',
    labelKey: 'Services',
    children: [
      { path: '/construction', labelKey: 'Constructions' },
      { path: '/ImportExport', labelKey: 'ImportExport' },
      { path: '/gaslpg', labelKey: 'GasLPG' },
      { path: '/factoryOverview', labelKey: 'CrushingPlant' },
      { path: '/apartment', labelKey: 'Apartment' },
    ],
  },
  {
    type: 'dropdown',
    labelKey: 'Projects',
    children: [
      { path: '/project', labelKey: 'ProjectsPending' },
      { path: '/project-2', labelKey: 'projectcompleted' },
    ],
  },
  { type: 'link', path: '/about', labelKey: 'About' },
  { type: 'link', path: '/blog-1', labelKey: 'News' },
  { type: 'link', path: '/contact', labelKey: 'Contact' },
];

export const MOBILE_NAV_BREAKPOINT = 1200;
